export interface Penguin {
  /** species of penguin */
  species: 'Adelie' | 'Chinstrap' | 'Gentoo'
  /** island of penguin */
  island: 'Biscoe' | 'Dream' | 'Torgersen'
  /** beak length (mm) */
  beakLength: number | null
  /** beak depth (mm) */
  beakDepth: number | null
  /** flipper length (mm) */
  flipperLength: number | null
  /** body mass (g) */
  bodyMass: number | null
  /** 'Male', 'Female' (contains uncategorized) */
  sex: string | null
}

/**
 * **Physical characteristics of penguins on Antarctic islands**. Data were collected and made available by [Dr. Kristen Gorman](https://www.uaf.edu/cfos/people/faculty/detail/kristen-gorman.php) and the [Palmer Station, Antarctica LTER](https://pallter.marine.rutgers.edu/), a member of the [Long Term Ecological Research Network](https://lternet.edu/)
 *
 * Horst AM, Hill AP, Gorman KB (2020). palmerpenguins: Palmer Archipelago (Antarctica) penguin data. R package version 0.1.0. [palmerpenguins](https://allisonhorst.github.io/palmerpenguins/). doi: [10.5281/zenodo.3960218](https://doi.org/10.5281/zenodo.3960218).
 */
export const penguins: Penguin[] = [
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 39.1,
    beakDepth: 18.7,
    flipperLength: 181,
    bodyMass: 3750,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 39.5,
    beakDepth: 17.4,
    flipperLength: 186,
    bodyMass: 3800,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 40.3,
    beakDepth: 18,
    flipperLength: 195,
    bodyMass: 3250,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: null,
    beakDepth: null,
    flipperLength: null,
    bodyMass: null,
    sex: null,
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 36.7,
    beakDepth: 19.3,
    flipperLength: 193,
    bodyMass: 3450,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 39.3,
    beakDepth: 20.6,
    flipperLength: 190,
    bodyMass: 3650,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 38.9,
    beakDepth: 17.8,
    flipperLength: 181,
    bodyMass: 3625,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 39.2,
    beakDepth: 19.6,
    flipperLength: 195,
    bodyMass: 4675,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 34.1,
    beakDepth: 18.1,
    flipperLength: 193,
    bodyMass: 3475,
    sex: null,
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 42,
    beakDepth: 20.2,
    flipperLength: 190,
    bodyMass: 4250,
    sex: null,
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 37.8,
    beakDepth: 17.1,
    flipperLength: 186,
    bodyMass: 3300,
    sex: null,
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 37.8,
    beakDepth: 17.3,
    flipperLength: 180,
    bodyMass: 3700,
    sex: null,
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 41.1,
    beakDepth: 17.6,
    flipperLength: 182,
    bodyMass: 3200,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 38.6,
    beakDepth: 21.2,
    flipperLength: 191,
    bodyMass: 3800,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 34.6,
    beakDepth: 21.1,
    flipperLength: 198,
    bodyMass: 4400,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 36.6,
    beakDepth: 17.8,
    flipperLength: 185,
    bodyMass: 3700,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 38.7,
    beakDepth: 19,
    flipperLength: 195,
    bodyMass: 3450,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 42.5,
    beakDepth: 20.7,
    flipperLength: 197,
    bodyMass: 4500,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 34.4,
    beakDepth: 18.4,
    flipperLength: 184,
    bodyMass: 3325,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 46,
    beakDepth: 21.5,
    flipperLength: 194,
    bodyMass: 4200,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 37.8,
    beakDepth: 18.3,
    flipperLength: 174,
    bodyMass: 3400,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 37.7,
    beakDepth: 18.7,
    flipperLength: 180,
    bodyMass: 3600,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 35.9,
    beakDepth: 19.2,
    flipperLength: 189,
    bodyMass: 3800,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 38.2,
    beakDepth: 18.1,
    flipperLength: 185,
    bodyMass: 3950,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 38.8,
    beakDepth: 17.2,
    flipperLength: 180,
    bodyMass: 3800,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 35.3,
    beakDepth: 18.9,
    flipperLength: 187,
    bodyMass: 3800,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 40.6,
    beakDepth: 18.6,
    flipperLength: 183,
    bodyMass: 3550,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 40.5,
    beakDepth: 17.9,
    flipperLength: 187,
    bodyMass: 3200,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 37.9,
    beakDepth: 18.6,
    flipperLength: 172,
    bodyMass: 3150,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 40.5,
    beakDepth: 18.9,
    flipperLength: 180,
    bodyMass: 3950,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 39.5,
    beakDepth: 16.7,
    flipperLength: 178,
    bodyMass: 3250,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 37.2,
    beakDepth: 18.1,
    flipperLength: 178,
    bodyMass: 3900,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 39.5,
    beakDepth: 17.8,
    flipperLength: 188,
    bodyMass: 3300,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 40.9,
    beakDepth: 18.9,
    flipperLength: 184,
    bodyMass: 3900,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 36.4,
    beakDepth: 17,
    flipperLength: 195,
    bodyMass: 3325,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 39.2,
    beakDepth: 21.1,
    flipperLength: 196,
    bodyMass: 4150,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 38.8,
    beakDepth: 20,
    flipperLength: 190,
    bodyMass: 3950,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 42.2,
    beakDepth: 18.5,
    flipperLength: 180,
    bodyMass: 3550,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 37.6,
    beakDepth: 19.3,
    flipperLength: 181,
    bodyMass: 3300,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 39.8,
    beakDepth: 19.1,
    flipperLength: 184,
    bodyMass: 4650,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 36.5,
    beakDepth: 18,
    flipperLength: 182,
    bodyMass: 3150,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 40.8,
    beakDepth: 18.4,
    flipperLength: 195,
    bodyMass: 3900,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 36,
    beakDepth: 18.5,
    flipperLength: 186,
    bodyMass: 3100,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 44.1,
    beakDepth: 19.7,
    flipperLength: 196,
    bodyMass: 4400,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 37,
    beakDepth: 16.9,
    flipperLength: 185,
    bodyMass: 3000,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 39.6,
    beakDepth: 18.8,
    flipperLength: 190,
    bodyMass: 4600,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 41.1,
    beakDepth: 19,
    flipperLength: 182,
    bodyMass: 3425,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 37.5,
    beakDepth: 18.9,
    flipperLength: 179,
    bodyMass: 2975,
    sex: null,
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 36,
    beakDepth: 17.9,
    flipperLength: 190,
    bodyMass: 3450,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 42.3,
    beakDepth: 21.2,
    flipperLength: 191,
    bodyMass: 4150,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 39.6,
    beakDepth: 17.7,
    flipperLength: 186,
    bodyMass: 3500,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 40.1,
    beakDepth: 18.9,
    flipperLength: 188,
    bodyMass: 4300,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 35,
    beakDepth: 17.9,
    flipperLength: 190,
    bodyMass: 3450,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 42,
    beakDepth: 19.5,
    flipperLength: 200,
    bodyMass: 4050,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 34.5,
    beakDepth: 18.1,
    flipperLength: 187,
    bodyMass: 2900,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 41.4,
    beakDepth: 18.6,
    flipperLength: 191,
    bodyMass: 3700,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 39,
    beakDepth: 17.5,
    flipperLength: 186,
    bodyMass: 3550,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 40.6,
    beakDepth: 18.8,
    flipperLength: 193,
    bodyMass: 3800,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 36.5,
    beakDepth: 16.6,
    flipperLength: 181,
    bodyMass: 2850,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 37.6,
    beakDepth: 19.1,
    flipperLength: 194,
    bodyMass: 3750,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 35.7,
    beakDepth: 16.9,
    flipperLength: 185,
    bodyMass: 3150,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 41.3,
    beakDepth: 21.1,
    flipperLength: 195,
    bodyMass: 4400,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 37.6,
    beakDepth: 17,
    flipperLength: 185,
    bodyMass: 3600,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 41.1,
    beakDepth: 18.2,
    flipperLength: 192,
    bodyMass: 4050,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 36.4,
    beakDepth: 17.1,
    flipperLength: 184,
    bodyMass: 2850,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 41.6,
    beakDepth: 18,
    flipperLength: 192,
    bodyMass: 3950,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 35.5,
    beakDepth: 16.2,
    flipperLength: 195,
    bodyMass: 3350,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 41.1,
    beakDepth: 19.1,
    flipperLength: 188,
    bodyMass: 4100,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 35.9,
    beakDepth: 16.6,
    flipperLength: 190,
    bodyMass: 3050,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 41.8,
    beakDepth: 19.4,
    flipperLength: 198,
    bodyMass: 4450,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 33.5,
    beakDepth: 19,
    flipperLength: 190,
    bodyMass: 3600,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 39.7,
    beakDepth: 18.4,
    flipperLength: 190,
    bodyMass: 3900,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 39.6,
    beakDepth: 17.2,
    flipperLength: 196,
    bodyMass: 3550,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 45.8,
    beakDepth: 18.9,
    flipperLength: 197,
    bodyMass: 4150,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 35.5,
    beakDepth: 17.5,
    flipperLength: 190,
    bodyMass: 3700,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 42.8,
    beakDepth: 18.5,
    flipperLength: 195,
    bodyMass: 4250,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 40.9,
    beakDepth: 16.8,
    flipperLength: 191,
    bodyMass: 3700,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 37.2,
    beakDepth: 19.4,
    flipperLength: 184,
    bodyMass: 3900,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 36.2,
    beakDepth: 16.1,
    flipperLength: 187,
    bodyMass: 3550,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 42.1,
    beakDepth: 19.1,
    flipperLength: 195,
    bodyMass: 4000,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 34.6,
    beakDepth: 17.2,
    flipperLength: 189,
    bodyMass: 3200,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 42.9,
    beakDepth: 17.6,
    flipperLength: 196,
    bodyMass: 4700,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 36.7,
    beakDepth: 18.8,
    flipperLength: 187,
    bodyMass: 3800,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 35.1,
    beakDepth: 19.4,
    flipperLength: 193,
    bodyMass: 4200,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 37.3,
    beakDepth: 17.8,
    flipperLength: 191,
    bodyMass: 3350,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 41.3,
    beakDepth: 20.3,
    flipperLength: 194,
    bodyMass: 3550,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 36.3,
    beakDepth: 19.5,
    flipperLength: 190,
    bodyMass: 3800,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 36.9,
    beakDepth: 18.6,
    flipperLength: 189,
    bodyMass: 3500,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 38.3,
    beakDepth: 19.2,
    flipperLength: 189,
    bodyMass: 3950,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 38.9,
    beakDepth: 18.8,
    flipperLength: 190,
    bodyMass: 3600,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 35.7,
    beakDepth: 18,
    flipperLength: 202,
    bodyMass: 3550,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 41.1,
    beakDepth: 18.1,
    flipperLength: 205,
    bodyMass: 4300,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 34,
    beakDepth: 17.1,
    flipperLength: 185,
    bodyMass: 3400,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 39.6,
    beakDepth: 18.1,
    flipperLength: 186,
    bodyMass: 4450,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 36.2,
    beakDepth: 17.3,
    flipperLength: 187,
    bodyMass: 3300,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 40.8,
    beakDepth: 18.9,
    flipperLength: 208,
    bodyMass: 4300,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 38.1,
    beakDepth: 18.6,
    flipperLength: 190,
    bodyMass: 3700,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 40.3,
    beakDepth: 18.5,
    flipperLength: 196,
    bodyMass: 4350,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 33.1,
    beakDepth: 16.1,
    flipperLength: 178,
    bodyMass: 2900,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 43.2,
    beakDepth: 18.5,
    flipperLength: 192,
    bodyMass: 4100,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 35,
    beakDepth: 17.9,
    flipperLength: 192,
    bodyMass: 3725,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 41,
    beakDepth: 20,
    flipperLength: 203,
    bodyMass: 4725,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 37.7,
    beakDepth: 16,
    flipperLength: 183,
    bodyMass: 3075,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 37.8,
    beakDepth: 20,
    flipperLength: 190,
    bodyMass: 4250,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 37.9,
    beakDepth: 18.6,
    flipperLength: 193,
    bodyMass: 2925,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 39.7,
    beakDepth: 18.9,
    flipperLength: 184,
    bodyMass: 3550,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 38.6,
    beakDepth: 17.2,
    flipperLength: 199,
    bodyMass: 3750,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 38.2,
    beakDepth: 20,
    flipperLength: 190,
    bodyMass: 3900,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 38.1,
    beakDepth: 17,
    flipperLength: 181,
    bodyMass: 3175,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 43.2,
    beakDepth: 19,
    flipperLength: 197,
    bodyMass: 4775,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 38.1,
    beakDepth: 16.5,
    flipperLength: 198,
    bodyMass: 3825,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 45.6,
    beakDepth: 20.3,
    flipperLength: 191,
    bodyMass: 4600,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 39.7,
    beakDepth: 17.7,
    flipperLength: 193,
    bodyMass: 3200,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 42.2,
    beakDepth: 19.5,
    flipperLength: 197,
    bodyMass: 4275,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 39.6,
    beakDepth: 20.7,
    flipperLength: 191,
    bodyMass: 3900,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Biscoe',
    beakLength: 42.7,
    beakDepth: 18.3,
    flipperLength: 196,
    bodyMass: 4075,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 38.6,
    beakDepth: 17,
    flipperLength: 188,
    bodyMass: 2900,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 37.3,
    beakDepth: 20.5,
    flipperLength: 199,
    bodyMass: 3775,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 35.7,
    beakDepth: 17,
    flipperLength: 189,
    bodyMass: 3350,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 41.1,
    beakDepth: 18.6,
    flipperLength: 189,
    bodyMass: 3325,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 36.2,
    beakDepth: 17.2,
    flipperLength: 187,
    bodyMass: 3150,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 37.7,
    beakDepth: 19.8,
    flipperLength: 198,
    bodyMass: 3500,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 40.2,
    beakDepth: 17,
    flipperLength: 176,
    bodyMass: 3450,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 41.4,
    beakDepth: 18.5,
    flipperLength: 202,
    bodyMass: 3875,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 35.2,
    beakDepth: 15.9,
    flipperLength: 186,
    bodyMass: 3050,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 40.6,
    beakDepth: 19,
    flipperLength: 199,
    bodyMass: 4000,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 38.8,
    beakDepth: 17.6,
    flipperLength: 191,
    bodyMass: 3275,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 41.5,
    beakDepth: 18.3,
    flipperLength: 195,
    bodyMass: 4300,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 39,
    beakDepth: 17.1,
    flipperLength: 191,
    bodyMass: 3050,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 44.1,
    beakDepth: 18,
    flipperLength: 210,
    bodyMass: 4000,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 38.5,
    beakDepth: 17.9,
    flipperLength: 190,
    bodyMass: 3325,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Torgersen',
    beakLength: 43.1,
    beakDepth: 19.2,
    flipperLength: 197,
    bodyMass: 3500,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 36.8,
    beakDepth: 18.5,
    flipperLength: 193,
    bodyMass: 3500,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 37.5,
    beakDepth: 18.5,
    flipperLength: 199,
    bodyMass: 4475,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 38.1,
    beakDepth: 17.6,
    flipperLength: 187,
    bodyMass: 3425,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 41.1,
    beakDepth: 17.5,
    flipperLength: 190,
    bodyMass: 3900,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 35.6,
    beakDepth: 17.5,
    flipperLength: 191,
    bodyMass: 3175,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 40.2,
    beakDepth: 20.1,
    flipperLength: 200,
    bodyMass: 3975,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 37,
    beakDepth: 16.5,
    flipperLength: 185,
    bodyMass: 3400,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 39.7,
    beakDepth: 17.9,
    flipperLength: 193,
    bodyMass: 4250,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 40.2,
    beakDepth: 17.1,
    flipperLength: 193,
    bodyMass: 3400,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 40.6,
    beakDepth: 17.2,
    flipperLength: 187,
    bodyMass: 3475,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 32.1,
    beakDepth: 15.5,
    flipperLength: 188,
    bodyMass: 3050,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 40.7,
    beakDepth: 17,
    flipperLength: 190,
    bodyMass: 3725,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 37.3,
    beakDepth: 16.8,
    flipperLength: 192,
    bodyMass: 3000,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 39,
    beakDepth: 18.7,
    flipperLength: 185,
    bodyMass: 3650,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 39.2,
    beakDepth: 18.6,
    flipperLength: 190,
    bodyMass: 4250,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 36.6,
    beakDepth: 18.4,
    flipperLength: 184,
    bodyMass: 3475,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 36,
    beakDepth: 17.8,
    flipperLength: 195,
    bodyMass: 3450,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 37.8,
    beakDepth: 18.1,
    flipperLength: 193,
    bodyMass: 3750,
    sex: 'Male',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 36,
    beakDepth: 17.1,
    flipperLength: 187,
    bodyMass: 3700,
    sex: 'Female',
  },
  {
    species: 'Adelie',
    island: 'Dream',
    beakLength: 41.5,
    beakDepth: 18.5,
    flipperLength: 201,
    bodyMass: 4000,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 46.5,
    beakDepth: 17.9,
    flipperLength: 192,
    bodyMass: 3500,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 50,
    beakDepth: 19.5,
    flipperLength: 196,
    bodyMass: 3900,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 51.3,
    beakDepth: 19.2,
    flipperLength: 193,
    bodyMass: 3650,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 45.4,
    beakDepth: 18.7,
    flipperLength: 188,
    bodyMass: 3525,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 52.7,
    beakDepth: 19.8,
    flipperLength: 197,
    bodyMass: 3725,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 45.2,
    beakDepth: 17.8,
    flipperLength: 198,
    bodyMass: 3950,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 46.1,
    beakDepth: 18.2,
    flipperLength: 178,
    bodyMass: 3250,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 51.3,
    beakDepth: 18.2,
    flipperLength: 197,
    bodyMass: 3750,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 46,
    beakDepth: 18.9,
    flipperLength: 195,
    bodyMass: 4150,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 51.3,
    beakDepth: 19.9,
    flipperLength: 198,
    bodyMass: 3700,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 46.6,
    beakDepth: 17.8,
    flipperLength: 193,
    bodyMass: 3800,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 51.7,
    beakDepth: 20.3,
    flipperLength: 194,
    bodyMass: 3775,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 47,
    beakDepth: 17.3,
    flipperLength: 185,
    bodyMass: 3700,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 52,
    beakDepth: 18.1,
    flipperLength: 201,
    bodyMass: 4050,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 45.9,
    beakDepth: 17.1,
    flipperLength: 190,
    bodyMass: 3575,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 50.5,
    beakDepth: 19.6,
    flipperLength: 201,
    bodyMass: 4050,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 50.3,
    beakDepth: 20,
    flipperLength: 197,
    bodyMass: 3300,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 58,
    beakDepth: 17.8,
    flipperLength: 181,
    bodyMass: 3700,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 46.4,
    beakDepth: 18.6,
    flipperLength: 190,
    bodyMass: 3450,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 49.2,
    beakDepth: 18.2,
    flipperLength: 195,
    bodyMass: 4400,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 42.4,
    beakDepth: 17.3,
    flipperLength: 181,
    bodyMass: 3600,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 48.5,
    beakDepth: 17.5,
    flipperLength: 191,
    bodyMass: 3400,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 43.2,
    beakDepth: 16.6,
    flipperLength: 187,
    bodyMass: 2900,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 50.6,
    beakDepth: 19.4,
    flipperLength: 193,
    bodyMass: 3800,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 46.7,
    beakDepth: 17.9,
    flipperLength: 195,
    bodyMass: 3300,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 52,
    beakDepth: 19,
    flipperLength: 197,
    bodyMass: 4150,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 50.5,
    beakDepth: 18.4,
    flipperLength: 200,
    bodyMass: 3400,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 49.5,
    beakDepth: 19,
    flipperLength: 200,
    bodyMass: 3800,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 46.4,
    beakDepth: 17.8,
    flipperLength: 191,
    bodyMass: 3700,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 52.8,
    beakDepth: 20,
    flipperLength: 205,
    bodyMass: 4550,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 40.9,
    beakDepth: 16.6,
    flipperLength: 187,
    bodyMass: 3200,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 54.2,
    beakDepth: 20.8,
    flipperLength: 201,
    bodyMass: 4300,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 42.5,
    beakDepth: 16.7,
    flipperLength: 187,
    bodyMass: 3350,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 51,
    beakDepth: 18.8,
    flipperLength: 203,
    bodyMass: 4100,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 49.7,
    beakDepth: 18.6,
    flipperLength: 195,
    bodyMass: 3600,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 47.5,
    beakDepth: 16.8,
    flipperLength: 199,
    bodyMass: 3900,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 47.6,
    beakDepth: 18.3,
    flipperLength: 195,
    bodyMass: 3850,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 52,
    beakDepth: 20.7,
    flipperLength: 210,
    bodyMass: 4800,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 46.9,
    beakDepth: 16.6,
    flipperLength: 192,
    bodyMass: 2700,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 53.5,
    beakDepth: 19.9,
    flipperLength: 205,
    bodyMass: 4500,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 49,
    beakDepth: 19.5,
    flipperLength: 210,
    bodyMass: 3950,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 46.2,
    beakDepth: 17.5,
    flipperLength: 187,
    bodyMass: 3650,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 50.9,
    beakDepth: 19.1,
    flipperLength: 196,
    bodyMass: 3550,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 45.5,
    beakDepth: 17,
    flipperLength: 196,
    bodyMass: 3500,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 50.9,
    beakDepth: 17.9,
    flipperLength: 196,
    bodyMass: 3675,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 50.8,
    beakDepth: 18.5,
    flipperLength: 201,
    bodyMass: 4450,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 50.1,
    beakDepth: 17.9,
    flipperLength: 190,
    bodyMass: 3400,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 49,
    beakDepth: 19.6,
    flipperLength: 212,
    bodyMass: 4300,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 51.5,
    beakDepth: 18.7,
    flipperLength: 187,
    bodyMass: 3250,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 49.8,
    beakDepth: 17.3,
    flipperLength: 198,
    bodyMass: 3675,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 48.1,
    beakDepth: 16.4,
    flipperLength: 199,
    bodyMass: 3325,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 51.4,
    beakDepth: 19,
    flipperLength: 201,
    bodyMass: 3950,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 45.7,
    beakDepth: 17.3,
    flipperLength: 193,
    bodyMass: 3600,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 50.7,
    beakDepth: 19.7,
    flipperLength: 203,
    bodyMass: 4050,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 42.5,
    beakDepth: 17.3,
    flipperLength: 187,
    bodyMass: 3350,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 52.2,
    beakDepth: 18.8,
    flipperLength: 197,
    bodyMass: 3450,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 45.2,
    beakDepth: 16.6,
    flipperLength: 191,
    bodyMass: 3250,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 49.3,
    beakDepth: 19.9,
    flipperLength: 203,
    bodyMass: 4050,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 50.2,
    beakDepth: 18.8,
    flipperLength: 202,
    bodyMass: 3800,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 45.6,
    beakDepth: 19.4,
    flipperLength: 194,
    bodyMass: 3525,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 51.9,
    beakDepth: 19.5,
    flipperLength: 206,
    bodyMass: 3950,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 46.8,
    beakDepth: 16.5,
    flipperLength: 189,
    bodyMass: 3650,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 45.7,
    beakDepth: 17,
    flipperLength: 195,
    bodyMass: 3650,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 55.8,
    beakDepth: 19.8,
    flipperLength: 207,
    bodyMass: 4000,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 43.5,
    beakDepth: 18.1,
    flipperLength: 202,
    bodyMass: 3400,
    sex: 'Female',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 49.6,
    beakDepth: 18.2,
    flipperLength: 193,
    bodyMass: 3775,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 50.8,
    beakDepth: 19,
    flipperLength: 210,
    bodyMass: 4100,
    sex: 'Male',
  },
  {
    species: 'Chinstrap',
    island: 'Dream',
    beakLength: 50.2,
    beakDepth: 18.7,
    flipperLength: 198,
    bodyMass: 3775,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 46.1,
    beakDepth: 13.2,
    flipperLength: 211,
    bodyMass: 4500,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 50,
    beakDepth: 16.3,
    flipperLength: 230,
    bodyMass: 5700,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 48.7,
    beakDepth: 14.1,
    flipperLength: 210,
    bodyMass: 4450,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 50,
    beakDepth: 15.2,
    flipperLength: 218,
    bodyMass: 5700,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 47.6,
    beakDepth: 14.5,
    flipperLength: 215,
    bodyMass: 5400,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 46.5,
    beakDepth: 13.5,
    flipperLength: 210,
    bodyMass: 4550,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 45.4,
    beakDepth: 14.6,
    flipperLength: 211,
    bodyMass: 4800,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 46.7,
    beakDepth: 15.3,
    flipperLength: 219,
    bodyMass: 5200,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 43.3,
    beakDepth: 13.4,
    flipperLength: 209,
    bodyMass: 4400,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 46.8,
    beakDepth: 15.4,
    flipperLength: 215,
    bodyMass: 5150,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 40.9,
    beakDepth: 13.7,
    flipperLength: 214,
    bodyMass: 4650,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 49,
    beakDepth: 16.1,
    flipperLength: 216,
    bodyMass: 5550,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 45.5,
    beakDepth: 13.7,
    flipperLength: 214,
    bodyMass: 4650,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 48.4,
    beakDepth: 14.6,
    flipperLength: 213,
    bodyMass: 5850,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 45.8,
    beakDepth: 14.6,
    flipperLength: 210,
    bodyMass: 4200,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 49.3,
    beakDepth: 15.7,
    flipperLength: 217,
    bodyMass: 5850,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 42,
    beakDepth: 13.5,
    flipperLength: 210,
    bodyMass: 4150,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 49.2,
    beakDepth: 15.2,
    flipperLength: 221,
    bodyMass: 6300,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 46.2,
    beakDepth: 14.5,
    flipperLength: 209,
    bodyMass: 4800,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 48.7,
    beakDepth: 15.1,
    flipperLength: 222,
    bodyMass: 5350,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 50.2,
    beakDepth: 14.3,
    flipperLength: 218,
    bodyMass: 5700,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 45.1,
    beakDepth: 14.5,
    flipperLength: 215,
    bodyMass: 5000,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 46.5,
    beakDepth: 14.5,
    flipperLength: 213,
    bodyMass: 4400,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 46.3,
    beakDepth: 15.8,
    flipperLength: 215,
    bodyMass: 5050,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 42.9,
    beakDepth: 13.1,
    flipperLength: 215,
    bodyMass: 5000,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 46.1,
    beakDepth: 15.1,
    flipperLength: 215,
    bodyMass: 5100,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 44.5,
    beakDepth: 14.3,
    flipperLength: 216,
    bodyMass: 4100,
    sex: null,
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 47.8,
    beakDepth: 15,
    flipperLength: 215,
    bodyMass: 5650,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 48.2,
    beakDepth: 14.3,
    flipperLength: 210,
    bodyMass: 4600,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 50,
    beakDepth: 15.3,
    flipperLength: 220,
    bodyMass: 5550,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 47.3,
    beakDepth: 15.3,
    flipperLength: 222,
    bodyMass: 5250,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 42.8,
    beakDepth: 14.2,
    flipperLength: 209,
    bodyMass: 4700,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 45.1,
    beakDepth: 14.5,
    flipperLength: 207,
    bodyMass: 5050,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 59.6,
    beakDepth: 17,
    flipperLength: 230,
    bodyMass: 6050,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 49.1,
    beakDepth: 14.8,
    flipperLength: 220,
    bodyMass: 5150,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 48.4,
    beakDepth: 16.3,
    flipperLength: 220,
    bodyMass: 5400,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 42.6,
    beakDepth: 13.7,
    flipperLength: 213,
    bodyMass: 4950,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 44.4,
    beakDepth: 17.3,
    flipperLength: 219,
    bodyMass: 5250,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 44,
    beakDepth: 13.6,
    flipperLength: 208,
    bodyMass: 4350,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 48.7,
    beakDepth: 15.7,
    flipperLength: 208,
    bodyMass: 5350,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 42.7,
    beakDepth: 13.7,
    flipperLength: 208,
    bodyMass: 3950,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 49.6,
    beakDepth: 16,
    flipperLength: 225,
    bodyMass: 5700,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 45.3,
    beakDepth: 13.7,
    flipperLength: 210,
    bodyMass: 4300,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 49.6,
    beakDepth: 15,
    flipperLength: 216,
    bodyMass: 4750,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 50.5,
    beakDepth: 15.9,
    flipperLength: 222,
    bodyMass: 5550,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 43.6,
    beakDepth: 13.9,
    flipperLength: 217,
    bodyMass: 4900,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 45.5,
    beakDepth: 13.9,
    flipperLength: 210,
    bodyMass: 4200,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 50.5,
    beakDepth: 15.9,
    flipperLength: 225,
    bodyMass: 5400,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 44.9,
    beakDepth: 13.3,
    flipperLength: 213,
    bodyMass: 5100,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 45.2,
    beakDepth: 15.8,
    flipperLength: 215,
    bodyMass: 5300,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 46.6,
    beakDepth: 14.2,
    flipperLength: 210,
    bodyMass: 4850,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 48.5,
    beakDepth: 14.1,
    flipperLength: 220,
    bodyMass: 5300,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 45.1,
    beakDepth: 14.4,
    flipperLength: 210,
    bodyMass: 4400,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 50.1,
    beakDepth: 15,
    flipperLength: 225,
    bodyMass: 5000,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 46.5,
    beakDepth: 14.4,
    flipperLength: 217,
    bodyMass: 4900,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 45,
    beakDepth: 15.4,
    flipperLength: 220,
    bodyMass: 5050,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 43.8,
    beakDepth: 13.9,
    flipperLength: 208,
    bodyMass: 4300,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 45.5,
    beakDepth: 15,
    flipperLength: 220,
    bodyMass: 5000,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 43.2,
    beakDepth: 14.5,
    flipperLength: 208,
    bodyMass: 4450,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 50.4,
    beakDepth: 15.3,
    flipperLength: 224,
    bodyMass: 5550,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 45.3,
    beakDepth: 13.8,
    flipperLength: 208,
    bodyMass: 4200,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 46.2,
    beakDepth: 14.9,
    flipperLength: 221,
    bodyMass: 5300,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 45.7,
    beakDepth: 13.9,
    flipperLength: 214,
    bodyMass: 4400,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 54.3,
    beakDepth: 15.7,
    flipperLength: 231,
    bodyMass: 5650,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 45.8,
    beakDepth: 14.2,
    flipperLength: 219,
    bodyMass: 4700,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 49.8,
    beakDepth: 16.8,
    flipperLength: 230,
    bodyMass: 5700,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 46.2,
    beakDepth: 14.4,
    flipperLength: 214,
    bodyMass: 4650,
    sex: null,
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 49.5,
    beakDepth: 16.2,
    flipperLength: 229,
    bodyMass: 5800,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 43.5,
    beakDepth: 14.2,
    flipperLength: 220,
    bodyMass: 4700,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 50.7,
    beakDepth: 15,
    flipperLength: 223,
    bodyMass: 5550,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 47.7,
    beakDepth: 15,
    flipperLength: 216,
    bodyMass: 4750,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 46.4,
    beakDepth: 15.6,
    flipperLength: 221,
    bodyMass: 5000,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 48.2,
    beakDepth: 15.6,
    flipperLength: 221,
    bodyMass: 5100,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 46.5,
    beakDepth: 14.8,
    flipperLength: 217,
    bodyMass: 5200,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 46.4,
    beakDepth: 15,
    flipperLength: 216,
    bodyMass: 4700,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 48.6,
    beakDepth: 16,
    flipperLength: 230,
    bodyMass: 5800,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 47.5,
    beakDepth: 14.2,
    flipperLength: 209,
    bodyMass: 4600,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 51.1,
    beakDepth: 16.3,
    flipperLength: 220,
    bodyMass: 6000,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 45.2,
    beakDepth: 13.8,
    flipperLength: 215,
    bodyMass: 4750,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 45.2,
    beakDepth: 16.4,
    flipperLength: 223,
    bodyMass: 5950,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 49.1,
    beakDepth: 14.5,
    flipperLength: 212,
    bodyMass: 4625,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 52.5,
    beakDepth: 15.6,
    flipperLength: 221,
    bodyMass: 5450,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 47.4,
    beakDepth: 14.6,
    flipperLength: 212,
    bodyMass: 4725,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 50,
    beakDepth: 15.9,
    flipperLength: 224,
    bodyMass: 5350,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 44.9,
    beakDepth: 13.8,
    flipperLength: 212,
    bodyMass: 4750,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 50.8,
    beakDepth: 17.3,
    flipperLength: 228,
    bodyMass: 5600,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 43.4,
    beakDepth: 14.4,
    flipperLength: 218,
    bodyMass: 4600,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 51.3,
    beakDepth: 14.2,
    flipperLength: 218,
    bodyMass: 5300,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 47.5,
    beakDepth: 14,
    flipperLength: 212,
    bodyMass: 4875,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 52.1,
    beakDepth: 17,
    flipperLength: 230,
    bodyMass: 5550,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 47.5,
    beakDepth: 15,
    flipperLength: 218,
    bodyMass: 4950,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 52.2,
    beakDepth: 17.1,
    flipperLength: 228,
    bodyMass: 5400,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 45.5,
    beakDepth: 14.5,
    flipperLength: 212,
    bodyMass: 4750,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 49.5,
    beakDepth: 16.1,
    flipperLength: 224,
    bodyMass: 5650,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 44.5,
    beakDepth: 14.7,
    flipperLength: 214,
    bodyMass: 4850,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 50.8,
    beakDepth: 15.7,
    flipperLength: 226,
    bodyMass: 5200,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 49.4,
    beakDepth: 15.8,
    flipperLength: 216,
    bodyMass: 4925,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 46.9,
    beakDepth: 14.6,
    flipperLength: 222,
    bodyMass: 4875,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 48.4,
    beakDepth: 14.4,
    flipperLength: 203,
    bodyMass: 4625,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 51.1,
    beakDepth: 16.5,
    flipperLength: 225,
    bodyMass: 5250,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 48.5,
    beakDepth: 15,
    flipperLength: 219,
    bodyMass: 4850,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 55.9,
    beakDepth: 17,
    flipperLength: 228,
    bodyMass: 5600,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 47.2,
    beakDepth: 15.5,
    flipperLength: 215,
    bodyMass: 4975,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 49.1,
    beakDepth: 15,
    flipperLength: 228,
    bodyMass: 5500,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 47.3,
    beakDepth: 13.8,
    flipperLength: 216,
    bodyMass: 4725,
    sex: null,
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 46.8,
    beakDepth: 16.1,
    flipperLength: 215,
    bodyMass: 5500,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 41.7,
    beakDepth: 14.7,
    flipperLength: 210,
    bodyMass: 4700,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 53.4,
    beakDepth: 15.8,
    flipperLength: 219,
    bodyMass: 5500,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 43.3,
    beakDepth: 14,
    flipperLength: 208,
    bodyMass: 4575,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 48.1,
    beakDepth: 15.1,
    flipperLength: 209,
    bodyMass: 5500,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 50.5,
    beakDepth: 15.2,
    flipperLength: 216,
    bodyMass: 5000,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 49.8,
    beakDepth: 15.9,
    flipperLength: 229,
    bodyMass: 5950,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 43.5,
    beakDepth: 15.2,
    flipperLength: 213,
    bodyMass: 4650,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 51.5,
    beakDepth: 16.3,
    flipperLength: 230,
    bodyMass: 5500,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 46.2,
    beakDepth: 14.1,
    flipperLength: 217,
    bodyMass: 4375,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 55.1,
    beakDepth: 16,
    flipperLength: 230,
    bodyMass: 5850,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 44.5,
    beakDepth: 15.7,
    flipperLength: 217,
    bodyMass: 4875,
    sex: '.',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 48.8,
    beakDepth: 16.2,
    flipperLength: 222,
    bodyMass: 6000,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 47.2,
    beakDepth: 13.7,
    flipperLength: 214,
    bodyMass: 4925,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: null,
    beakDepth: null,
    flipperLength: null,
    bodyMass: null,
    sex: null,
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 46.8,
    beakDepth: 14.3,
    flipperLength: 215,
    bodyMass: 4850,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 50.4,
    beakDepth: 15.7,
    flipperLength: 222,
    bodyMass: 5750,
    sex: 'Male',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 45.2,
    beakDepth: 14.8,
    flipperLength: 212,
    bodyMass: 5200,
    sex: 'Female',
  },
  {
    species: 'Gentoo',
    island: 'Biscoe',
    beakLength: 49.9,
    beakDepth: 16.1,
    flipperLength: 213,
    bodyMass: 5400,
    sex: 'Male',
  },
]
